import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useResto } from '../contexts/RestoContext';



const PageTitleUpdater = () => {
  const location = useLocation();
  const { restoData } = useResto();

  useEffect(() => {
    const pageTitle = document.querySelector('h1');
    const restoLabel = restoData.label;
    if (pageTitle) {
      const isHidden = window.getComputedStyle(pageTitle).display === 'none';
      
      if (!isHidden) {
        const newTitle = `${pageTitle.textContent} | ${restoLabel}`;
        document.title = newTitle;
      } else {
        document.title = restoLabel;
      }
    }
  }, [location]);

  return null;
};

export default PageTitleUpdater;
